<template>
  <div class="container-form">
    <div class="row register">
      <div class="col-lg-6"></div>
      <div class="col-lg-6">
        <form>
          <div class="form-data">
            <h2 class="bold-700">Olá!</h2>
            <h2 class="bold-700">Estamos felizes em ter você aqui :)</h2>
            <hr>
            <h3 class="form-label bold-700">Criar conta</h3>
            <input type="text" class="form-control mt-2" v-model="accountData.name" placeholder="Nome completo">
            <p class="mb-0 required-alert" v-show="invalid.name">*Campo obrigatório, insira nome e sobrenome</p>
            <input type="email" class="form-control mt-2" v-model="accountData.email" placeholder="E-mail">
            <p class="mb-0 required-alert" v-show="invalid.email" v-if="!emailUsed">*Campo obrigatório, insira um email válido</p>
            <p class="mb-0 required-alert" v-show="invalid.email" v-else>*Esse e-mail já foi cadastrado</p>
            <input type="tel" class="form-control mt-2" v-model="accountData.phone" @input="formatPhone" placeholder="Celular">
            <p class="mb-0 required-alert" v-show="invalid.phone">*Campo obrigatório, insira um telefone válido</p>
            <input type="password" class="form-control mt-2" v-model="accountData.password" placeholder="Senha">
            <p class="mb-0 required-alert" v-show="invalid.password">*A senha deve conter, no mínimo, 6 caracteres, com pelo menos:</p>
            <p class="mb-0 required-alert" v-show="invalid.password">- 1 caractere especial</p>
            <p class="mb-0 required-alert" v-show="invalid.password">- 1 letra maiúscula</p>
            <p class="mb-0 required-alert" v-show="invalid.password">- 1 letra minúscula</p>
            <p class="mb-0 required-alert" v-show="invalid.password">- 1 número</p>
            <input type="password" class="form-control mt-2" v-model="confirmPassword" placeholder="Confirme a senha">
            <p class="mb-0 required-alert" v-show="invalidConfirmPassword">*As senhas devem ser iguais</p>
            <div class="form-checkx mt-2">
              <input class="form-check-input ml-1" type="checkbox" id="termsAndConditions" v-model="termsAndConditions">
              <label class="form-check-label" for="termsAndConditions">Li e concordo com os</label>&nbsp;
              <span class="form-check-label">
                <a target="_blank" :href="termsUrl">termos de uso</a> e <a target="_blank" :href="privacyUrl">política de privacidade</a></span>
            </div>
            <p class="mb-0 required-alert" v-show="invalidTermsAndConditions">*É preciso aceitar os termos de uso e a política de privacidade</p>
            <div class="d-grid mt-4">
              <button @click.prevent="save()" type="submit" class="btn btn-save" :disabled="loading">
                <ButtonSpinner v-if="loading" />
                Criar conta
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapActions } from 'vuex';
import ButtonSpinner from "@/components/ButtonSpinner.vue";

export default {
  name: "FormRegister",
  components: {
    ButtonSpinner,
  },
  data() {
    return {
      loading: false,
      confirmPassword: "",
      invalidConfirmPassword: false,
      termsAndConditions: false,
      invalidTermsAndConditions: false,
      invalid: {
        name: false,
        email: false,
        phone: false,
        password: false
      },
      accountData: {
        name: "",
        email: "",
        phone: "",
        password: ""
      },
      emailUsed: false,
      termsUrl: `${process.env.VUE_APP_URL}/termos-de-uso`,
      privacyUrl: `${process.env.VUE_APP_URL}/politica-de-privacidade`,
    };
  },
  methods: {
    ...mapActions(['saveToken', 'saveEmail', 'saveRestId', 'preloadData']),
    formatPhone(event) {
      const input = event.target.value.replace(/\D/g, '');
      const formatted = input.replace(/^(\d{2})(\d{5})(\d{4}).*/, '($1) $2-$3');
      this.accountData.phone = formatted;
    },
    validatePassword(password) {
      if (
        password.length >= 6
        && /[A-Z]/.test(password)
        && /[a-z]/.test(password)
        && /[0-9]/.test(password)
        && /[!@#$%^&*(),.?":{}|<>-]/.test(password)
      ) {
        return true
      } else {
        return false
      }
    },
    valid(data) {
      let isvalid = true;

      // Validação do Nome Composto
      if (!data.name || !/\s/.test(data.name.trim())) {
        this.invalid.name = true;
        isvalid = false;
      } else {
        this.invalid.name = false;
      }

      // Validação do Email
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!data.email || !emailPattern.test(data.email)) {
        this.invalid.email = true;
        isvalid = false;
      } else {
        this.invalid.email = false;
      }

      // Validação do Telefone
      const phonePattern = /^\(\d{2}\) \d{5}-\d{4}$/;
      if (!data.phone || !phonePattern.test(data.phone)) {
        this.invalid.phone = true;
        isvalid = false;
      } else {
        this.invalid.phone = false;
      }

      // Validação da Senha
      if (!this.validatePassword(data.password) || data.password.trim().length === 0) {
        this.invalid.password = true;
        isvalid = false;
      } else {
        this.invalid.password = false;
      }

      return isvalid;
    },
    async save() {
      this.emailUsed = false;

      if (!this.valid(this.accountData)) {
        return;
      }

      if (this.accountData.password !== this.confirmPassword) {
        this.invalidConfirmPassword = true;
        return;
      }

      this.invalidConfirmPassword = false;

      if (!this.termsAndConditions) {
        this.invalidTermsAndConditions = true;
        return;
      }

      this.invalidTermsAndConditions = false;

      try {
        this.loading = true;
        const response = await axios.post(`${process.env.VUE_APP_LARAVEL_API_URL}/register-restaurant`, this.accountData);
        const token = response.data.token;
        const restId = response.data.user.restaurant_id;

        this.saveToken(token);
        this.saveEmail(this.accountData.email);
        this.saveRestId(restId);
        this.$store.commit('setRegistrationInProgress', true);
        this.$router.push({ name: 'register' });
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.error('Erro ao registrar o usuário:', error);
        if (error?.response?.data?.errors?.email) {
          this.invalid.email = true;
          this.emailUsed = true;
        }
      }
    }
  },
  async mounted() {
    this.$store.dispatch('resetStore');

    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');

    if (token) {
      // axios.get(`${process.env.VUE_APP_LARAVEL_API_URL}/verify-token`, {
      //   headers: {
      //     Authorization: `Bearer ${token}`
      //   }
      // }).then(response => {
      //   alert('Token válido: ' + response.data.message);
      // }).catch(error => {
      //   alert('Erro na verificação do token: ' + error.message);
      // });
      
      this.loading = true;
      await this.saveToken(token);
      await this.preloadData();
      setTimeout(() => {
        if (!this.$store.state.register) {
          this.saveEmail(this.loginData.login);
          this.$store.commit('setRegistrationInProgress', true);
          this.$router.push('/registro');
        }
        else if (this.$store.state.completeConfig) {
          this.$router.push('/visao');
        } else {
          this.$router.push('/horario');
        }
      }, 1000)
      setTimeout(() => {
        this.loading = false;
      }, 4000);
    }
  }
};
</script>

<style lang="scss" scoped>
.container-form {
  height: max-content;
  min-height: calc(100vh - 70px);
  margin: auto;
  padding: 0;
  border-radius: 0;
}

.container-form form {
  min-height: calc(100vh - 70px);
  padding: 20px 0;
  display: grid;
  place-items: center;
}

.container-form .form-data {
  padding: 40px 30px;
  border-radius: 16px;
  background-color: $gray-bg;
  min-width: 470px;
}

.container-form input {
  background-color: $white-primary !important;
  border: 1px solid #dee2e6 !important;
}

.container-form input[type='checkbox'] {
  border-radius: 3px !important;
  height: 18px !important;
}

.container-form input[type='checkbox']:checked {
  background-color: $light-green !important;
}

.container-form h2 {
  font-size: 22px;
}

.container-form h3 {
  font-size: 18px;
  margin-bottom: 15px;
}

hr {
  margin: 20px 0;
}

.mt-2 {
  margin-top: 12px !important;
}

.btn-save {
  background-color: #4caf50;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.btn-save:hover {
  background-color: #45a049;
}

.required-alert {
  color: red;
  font-size: 12px;
  max-width: 460px;
}
</style>
